import { Injectable } from '@angular/core';
import { EnviromentService } from './enviroment.service';
import { HttpClient } from '@angular/common/http';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { Equipment } from 'app/_models/Equipment';

@Injectable()
export class EquipmentService {

  baseUrl = '';
  
  constructor(private http: HttpClient, private enviromentService: EnviromentService, private oauthService: OAuthService) {
    this.baseUrl = enviromentService.getConfig().apiV2Url;
  }

  add(add: Equipment): Observable<number> {
    return this.http.post<number>(this.baseUrl + 'equipments', add);
  }

  delete(id: number): Observable<boolean> {
      return this.http.delete<boolean>(this.baseUrl + 'equipments/' + id);
  }

  update(update: Equipment): Observable<number> {
      return this.http.put<number>(this.baseUrl + 'equipments/' + update.id, update);
  }

  get(id: number): Observable<Equipment> {
    return this.http.get<Equipment>(this.baseUrl + '/equipments/' + id);
  }

  getByCenterId(centerId: number): Observable<Equipment[]>{
      return this.http.get<Equipment[]>(this.baseUrl + 'centers/' + centerId + '/equipments');
  }

}
